import ButtonSkeleton from '../../../../../../components/Button/skeleton';

const InformationSkeleton = () => {
  return <ButtonSkeleton width={20} height={20} />;
};

export default InformationSkeleton;
